import { render, staticRenderFns } from "./JAvatar.vue?vue&type=template&id=5943f572&scoped=true"
import script from "./JAvatar.vue?vue&type=script&lang=js"
export * from "./JAvatar.vue?vue&type=script&lang=js"
import style0 from "./JAvatar.vue?vue&type=style&index=0&id=5943f572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5943f572",
  null
  
)

export default component.exports